
import {serializable, alias, object, list, primitive} from 'serializr';

export class DashboardFilterModel {

	@serializable(alias('today', primitive()))
	today?: boolean;

	@serializable(alias('week', primitive()))
	week?: boolean;

	@serializable(alias('yesterday', primitive()))
	yesterday?: string;

	@serializable(alias('starting_date', primitive()))
	startingDate?: string;

	@serializable(alias('ending_date', primitive()))
	endingDate?: string;

	@serializable(alias('last_login_starting_date', primitive()))
	lastLoginStartingDate?: string;

	@serializable(alias('last_login_ending_date', primitive()))
	lastLoginEndingDate?: string;

	@serializable(alias('board', primitive()))
	board?: number;

	@serializable(alias('institute', primitive()))
	institute?: number;

	@serializable(alias('branch', primitive()))
	branch?: number;

	@serializable(alias('class_room', primitive()))
	classRoom?: number;

	@serializable(alias('branch_class_room', primitive()))
	branchClassRoom?: number;

	@serializable(alias('month', primitive()))
	month?: number;

	@serializable(alias('year', primitive()))
	year?: number;

	@serializable(alias('section', primitive()))
	section?: number;

	@serializable(alias('loggedIn', primitive()))
	loggedIn?: boolean;
}

export class StudentActivitiesFilterModel {
  id?: number;
  @serializable(alias("institute_id", primitive()))
  institute?: number;
  @serializable(alias("branch_id", primitive()))
  branch?: number;
  @serializable(alias("board_id", primitive()))
  board?: number;
  @serializable(alias("class_room_id", primitive()))
  classRoom?: number;
  @serializable(alias("branch_class_room_id", primitive()))
  branchClassRoom?: number;
  @serializable(alias("start_date", primitive()))
  startingDate?: string;
  @serializable(alias("end_date", primitive()))
  endingDate?: string;
  @serializable(alias("section_id", primitive()))
  section?: number;
}
